import React, { useEffect, useState } from 'react';
import UploadProducts from '../components/UploadProducts';
import SummaryApi from '../common';
import AdminProductCard from '../components/AdminProductCard';

const AllProducts = () => {
  const [ openUploadProduct, setOpenUploadProduct ] = useState(false)
  const [ allProduct,SetAllProduct ] = useState([])

  const fetchAllProduct = async () => {
    const response = await fetch(SummaryApi.allProduct.url)
    const responseData = await response.json()

    SetAllProduct(responseData?.data || [])
  }

  useEffect(()=>{
    fetchAllProduct()
  },[])

  return (
    <div>
      <div className='bg-white py-2 px-4 flex justify-between items-center' style={{fontFamily: 'segoe'}}>
        <h2 className='font-bold text-lg pt-3'>All products</h2>
        <button className='border-2 border-[#5a3620] text-[#5a3620] hover:bg-[#5a3620] hover:text-white transition-all py-2 px-3 mt-2 rounded-full' onClick={()=>setOpenUploadProduct(true)}>Upload Product</button>
      </div>

      {/** all product */}
      <div className='flex items-center flex-wrap gap-5 py-4 h-[calc(100vh-200px)] overflow-y-scroll'>
        {
          allProduct.map((product, index)=>{
            return(
              <AdminProductCard data={product} key={index+"allProduct"} fetchData={fetchAllProduct}/>
            )
          })
        }
      </div>

      {/** upload product component */}
      {
        openUploadProduct && (
          <UploadProducts onClose={()=>setOpenUploadProduct(false)} fetchData={fetchAllProduct} />
        )
      }
    </div>
  )
}

export default AllProducts;